import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { CALCULATE_SCORE_MESSAGES } from '@app/presentation/mo-layout/calculate-score-msg.constant';

@Component({
  selector: 'layout-score-loading',
  templateUrl: './score-loading.component.html',
  styleUrls: ['./score-loading.component.scss'],
})
export class ScoreLoadingComponent implements OnInit {
  @Output() visitRecordEvent = new EventEmitter<boolean>();

  public messages = CALCULATE_SCORE_MESSAGES;
  public currentMessageIndex: number = 0;
  public shouldDisplayMessages: boolean = true;

  constructor(private _titleService: Title) {}

  ngOnInit(): void {
    this.visitRecordEvent.emit(true);
    this._titleService.setTitle('Validando datos personales');
    setInterval(() => {
      if (this.shouldDisplayMessages) {
        this.currentMessageIndex = (this.currentMessageIndex + 1) % this.messages.length;
      }
    }, 5000);
  }
}
